module.exports = __webpack_public_path__ + "static/assets/2ebf1a35a67b4271603e509fccad3d4d.ttf";